// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__296IU","clinicsSelect":"styles_clinicsSelect__yNiJV"};